import Chart from "react-apexcharts";

const FunnelChart = ({ stages = [], labels = {}, height = 280 }) => {
  if (!stages.length) return null;
  const categories = stages.map((s) => labels[s.key] || s.key);
  const series = [
    {
      name: "عدد",
      data: stages.map((s) => Number(s.count) || 0),
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Cairo, DM Sans, sans-serif",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 6,
        barHeight: "60%",
        distributed: true,
        dataLabels: { position: "center" },
      },
    },
    colors: ["#2152FF", "#5B7BFF", "#8DA4FB", "#BFD0FC"],
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const stage = stages[opts.dataPointIndex];
        const conv = stage?.conversionFromStart;
        if (conv === null || conv === undefined) return `${val}`;
        return `${val} · ${conv}%`;
      },
      style: { colors: ["#fff"], fontSize: "12px", fontWeight: 600 },
    },
    xaxis: {
      categories,
      labels: { style: { colors: "#707EAE", fontSize: "11px" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { style: { colors: "#252f40", fontSize: "12px" } },
    },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 4 },
    legend: { show: false },
    tooltip: { y: { formatter: (v) => `${v}` } },
  };
  return <Chart options={options} series={series} type="bar" height={height} />;
};

export default FunnelChart;
